import { GAME_LOAD_BATCH, GAME_LOAD_FULL, GAME_LOAD_LAZY } from 'app/constants/AppConstants';
import { getIsOldiPhone } from 'utils/AppleDeviceDetection';
class DeviceController {
  /**
   * Paul - Ive added iphone device type detection. My thinking was the small screen check is a
   * bit unfair for iphone 7 + users who have the RAM and power necessary to play the whole game.
   */
  constructor() {
    const w = screen.width;
    const h = screen.height;
    this.isOldIpad =
      window.devicePixelRatio == 1 && ((w == 1024 && h == 768) || (w == 768 && h == 1024)) && typeof window.androidBridge === 'undefined';
    this.isOldIphone = getIsOldiPhone();
    this.isKindle = this.isKindle();
    this.isNexus7 = navigator.userAgent.indexOf('Nexus 7') > -1;
    this.isGalaxyTab4 =
      navigator.userAgent.indexOf('SM-T530') > -1 || navigator.userAgent.indexOf('SM-T330') > -1 || navigator.userAgent.indexOf('GT-N8010') > -1;
    this.isSmallScreen = w <= 768 || h <= 768;

    this.requiresLightVersion = Phaser.Device.desktop ? false : this.doesRequireLightVersion();

    if (Phaser.Device.desktop === true) {
      this.gameLoadType = GAME_LOAD_LAZY;
    } else {
      this.gameLoadType = this.requiresLightVersion ? GAME_LOAD_BATCH : GAME_LOAD_LAZY;
    }

    // seperated these out so we can experiment easier with simple toggles
    this.allowTransitionTweens = this.requiresLightVersion == false;

    // check for query string overrides
    const loadTypeQuery = this.getParameterByName('loadtype');

    switch (loadTypeQuery) {
      case GAME_LOAD_BATCH:
        this.gameLoadType = GAME_LOAD_BATCH;
        break;
      case GAME_LOAD_LAZY:
        this.gameLoadType = GAME_LOAD_LAZY;
        break;
      case GAME_LOAD_FULL:
        this.gameLoadType = GAME_LOAD_FULL;
        break;
    }
  }

  getAppRenderTpye() {
    /*
     *  NOTE : Determine Render type based off of info in this class
     */
    let type = Phaser.AUTO;
    if (this.isOldAppleDevice() || this.isIE()) {
      type = Phaser.CANVAS;
    }
    return type;
  }

  getAppTransitionType() {
    //REMOVE THIS TO GET TRANSITIONS BACK
    let type = DeviceController.TRANSITIONS_NONE;
    return type;

    // let type = DeviceController.TRANSITIONS_FULL;
    // if (this.isOldAppleDevice()) {
    //   type = DeviceController.TRANSITIONS_LOWFI;
    // }
    // // type = DeviceController.TRANSITIONS_LOWFI;
    // return type;
  }

  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  doesRequireLightVersion() {
    // light version for some devices detection
    if (this.isOldIpad || this.isOldIphone || this.isKindle || this.isGalaxyTab4 || this.isNexus7) {
      return true;
    }
    return false;
  }

  isOldAppleDevice() {
    return false; //this.isOldIpad || this.isOldIphone;
  }

  isIE() {
    return navigator.appName == 'Microsoft Internet Explorer' || !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/));
  }

  isKindle() {
    let devices = [
      'KFSUWI',
      'KFAUWI',
      'KFDOWI',
      'KFGIWI',
      'KFFOWI',
      'KFMEWI',
      'KFTBWI',
      'KFARWI',
      'KFASWI',
      'KFSAWA',
      'KFSAWI',
      'KFAPWA',
      'KFAPWI',
      'KFAPWA',
      'KFAPWI',
      'KFSOWI',
      'KFJWA',
      'KFJWI',
      'KFTT',
      'KFOT',
      'Kindle Fire',
    ];
    for (let i = 0; i < devices.length; i++) {
      if (navigator.userAgent.indexOf(devices[i]) > -1) {
        return true;
      }
    }

    return false;
  }

  applyLightSettings(value) {
    this.requiresLightVersion = value;
  }
}
DeviceController.TRANSITIONS_FULL = 'TRANSITIONS_FULL';
DeviceController.TRANSITIONS_LOWFI = 'TRANSITIONS_LOWFI';
DeviceController.TRANSITIONS_NONE = 'TRANSITIONS_NONE';
export default DeviceController;
